import { useState, useEffect } from "react";
import { CheckBadgeIcon, CheckCircleIcon, Cog6ToothIcon, ExclamationCircleIcon, ArrowDownIcon } from "@heroicons/react/24/solid";

export default function SubstepViewer({ taskData }) {
    const [substeps, setSubsteps] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    console.log("taskData:", taskData);

    useEffect(() => {
    const fetchSubsteps = async () => {
        try {
            const response = await fetch(`https://api.insightos.co.uk/api/getsubsteps/${taskData}`, {
                method: "GET",  // ✅ Move method OUTSIDE headers
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
            });

            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const substeps = await response.json();

            console.log("substeps:", substeps);

            // Sort substeps by Step number
            substeps.data.sort((a, b) => a.Step - b.Step);

            setSubsteps(substeps.data);
        } catch (error) {
            console.error("Failed to fetch substeps:", error);
            setError(error);
        } finally {
            setLoading(false);
        }
    };

    fetchSubsteps();
}, [taskData]);  // ✅ If taskData is an object, use just taskData instead of taskData.id


    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    const typeIcons = {
        Action: <Cog6ToothIcon className="h-6 w-6 text-blue-500" />,
        Bridge: <ExclamationCircleIcon className="h-6 w-6 text-yellow-500" />,
        Expectation: <CheckCircleIcon className="h-6 w-6 text-purple-500" />,
      };
      
      return (
        <div className="flex flex-col items-center space-y-4">
          <h3 className="text-sm font-semibold text-gray-900">Substeps</h3>
          <ul className="flex flex-col items-center space-y-6">
            {substeps.map((substep, index) => (
              <div key={substep.id} className="flex flex-col items-center space-y-2">
                {/* Step number inside a smaller circle */}
                <div className="flex items-center justify-center w-8 h-8 rounded-full bg-emerald-500 text-gray-900 text-sm font-bold">
                  {substep.Step}
                </div>
      
                {/* Icon and description with improved spacing */}
                <div className="flex flex-col items-center text-center space-y-1">
                  <div className="flex justify-center items-center w-10 h-10">{typeIcons[substep.Type]}</div>
                  <p className="text-xs font-medium text-gray-900">{substep.Name}</p>
                  <p className="text-xs text-gray-500">{substep.Description}</p>
                </div>
      
                {/* Downward arrow between steps */}
                {index < substeps.length - 1 && (
                  <ArrowDownIcon className="h-4 w-4 text-indigo-600 animate-bounce mt-2" />
                )}
              </div>
            ))}
          </ul>
        </div>
      );
    }      